import { FacturationCodeDTO } from "../../Api/MedfarBilling/Dto/Responses/FacturationReponse";

class FacturationCode {
    public Code: string;
    public Description: string;
    public TypeCode: string;
    public Mesure1: string;
    public UnitLabel1: string;
    public UnitType1: string;
    public Mesure2: string;
    public UnitLabel2: string;
    public UnitType2: string;
    public Attribut: string;

    public IsChecked: boolean = false;

    public IsChecked45: boolean = false;
    public IsChecked60: boolean = false;
    public IsChecked75: boolean = false;
    public IsChecked90: boolean = false;
    public IsChecked105: boolean = false;

    public CodeGroupIdentifier: string;
    public BaseCode: number;

    public MoreThen500PatientModifier: number = 0;
    public MoreThen1000PatientModifier: number = 0;
    public MoreThen1500PatientModifier: number = 0;
    public Is80YearsOldModifier: number;
    public IsVulnerableModifier: number;

    public NomMedecinReferant: string;
    public LicenceMedecinReferant: string;

    public PrenomMedecinComm: string;
    public NomMedecinComm: string;
    public LicenceMedecinComm: string;
    public TypeMEdecinComm: string;
    public ProvinceMedecinComm: string;

    public AdditionalCodeSuggestions: string[];

    public MustBeVulnerable: boolean = false;
    public MustHaveAtLeast500Patient: boolean = false;

    public DateAccouchement: Date;
    public DateCSST: Date;

    public constructor(fields?: Partial<FacturationCode>) {
        (Object as any).assign(this, fields);
        if (fields?.CodeGroupIdentifier === "RDVPI--PERVUL")
            this.MustBeVulnerable = true;
    }

    public RefreshCode(Errors: ErrorFacturation[], moreThen500Patient: boolean, moreThen1000Patient: boolean, moreThen1500Patient: boolean, is80YearsOld: boolean, isVulnerable: boolean): ErrorFacturation[] {
        if (this.BaseCode === 0) {
            return;
        }

        if (isVulnerable === false && this.MustBeVulnerable) {
            var newError = new ErrorFacturation();
            newError.Text = "Le patient doît être vulnérable pour facturer l'acte " + this.BaseCode + ".";
            newError.Code = "NotVulnerable";

            Errors.push(newError);
        }

        if (this.MustHaveAtLeast500Patient === true && !(moreThen500Patient === true || moreThen1000Patient === true || moreThen1500Patient === true)) {
            var newError = new ErrorFacturation();
            newError.Text = "Vous devez avoir aumoins 500 inscriptions pour facturer cet l'acte " + this.BaseCode + ".";
            newError.Code = "MustHave500Patient";

            Errors.push(newError);
        }

        var tmpCode = this.BaseCode;

        if (moreThen500Patient === true && !isNaN(this.MoreThen500PatientModifier))
            tmpCode += this.MoreThen500PatientModifier;

        if (moreThen1000Patient === true && !isNaN(this.MoreThen1000PatientModifier))
            tmpCode += this.MoreThen1000PatientModifier;

        if (moreThen1500Patient === true && !isNaN(this.MoreThen1500PatientModifier))
            tmpCode += this.MoreThen1500PatientModifier;

        if (is80YearsOld === true && !isNaN(this.Is80YearsOldModifier))
            tmpCode += this.Is80YearsOldModifier;

        if (isVulnerable === true && !isNaN(this.IsVulnerableModifier))
            tmpCode += Math.abs(this.IsVulnerableModifier);

        this.Code = tmpCode.toString();

        return Errors;
    }

    public GetCombines(): number[] {
        var tmpList: number[] = [];

        tmpList.push(this.BaseCode);

        tmpList.push(this.BaseCode + this.Is80YearsOldModifier);
        tmpList.push(this.BaseCode + this.IsVulnerableModifier);
        tmpList.push(this.BaseCode + this.Is80YearsOldModifier + this.IsVulnerableModifier);

        tmpList.push(this.BaseCode + this.MoreThen500PatientModifier);
        tmpList.push(this.BaseCode + this.MoreThen500PatientModifier + this.Is80YearsOldModifier);
        tmpList.push(this.BaseCode + this.MoreThen500PatientModifier + this.IsVulnerableModifier);
        tmpList.push(this.BaseCode + this.MoreThen500PatientModifier + this.Is80YearsOldModifier + this.IsVulnerableModifier);

        tmpList.push(this.BaseCode + this.MoreThen1000PatientModifier);
        tmpList.push(this.BaseCode + this.MoreThen1000PatientModifier + this.Is80YearsOldModifier);
        tmpList.push(this.BaseCode + this.MoreThen1000PatientModifier + this.IsVulnerableModifier);
        tmpList.push(this.BaseCode + this.MoreThen1000PatientModifier + this.Is80YearsOldModifier + this.IsVulnerableModifier);

        tmpList.push(this.BaseCode + this.MoreThen1500PatientModifier);
        tmpList.push(this.BaseCode + this.MoreThen1500PatientModifier + this.Is80YearsOldModifier);
        tmpList.push(this.BaseCode + this.MoreThen1500PatientModifier + this.IsVulnerableModifier);
        tmpList.push(this.BaseCode + this.MoreThen1500PatientModifier + this.Is80YearsOldModifier + this.IsVulnerableModifier);

        return tmpList;
    }

    public ToString(): string {
        return "(" + this.Code + ")" + this.Description;
    }

    public static FromFacturationCodeDTO(codeDTO: FacturationCodeDTO, CodeGroupDictionaryByFinalCode: { [finalCode: number]: FacturationCode }): FacturationCode {
        let resolvedCodeGroup = CodeGroupDictionaryByFinalCode[codeDTO.CodeFacturation];

        let facCode = (resolvedCodeGroup != null) ? resolvedCodeGroup : new FacturationCode();
        facCode.Code = codeDTO.CodeFacturation;
        facCode.Description = codeDTO.Description;
        facCode.Mesure1 = codeDTO.Mesure1;
        facCode.UnitType1 = codeDTO.MesureType1;
        facCode.Mesure2 = codeDTO.Mesure2;
        facCode.UnitType2 = codeDTO.MesureType2;

        return facCode;
    }
}

class ErrorFacturation {
    public Code: string;
    public Text: string;

    public constructor(fields?: Partial<ErrorFacturation>) {
        Object.assign(this, fields);
    }
}

export { ErrorFacturation, FacturationCode };
